import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { FC } from 'react';

import { Button } from '@/components/ui/button';
import useBreakpoint from '@/hooks/use-break-point';

interface AddReleaseNoteProps {
  showFullLabel?: boolean;
  onClick: () => void;
}

const AddReleaseNote: FC<AddReleaseNoteProps> = ({ showFullLabel = false, onClick }) => {
  const { t } = useTranslation();
  const isTablet: boolean = useBreakpoint('tablet');

  const showShortLabel = isTablet && !showFullLabel;
  const buttonLabel = showShortLabel ? t('actions.add') : t('actions.add_new_release_note');

  return (
    <Button variant="default" className="rounded-lg" onClick={onClick}>
      <span>{buttonLabel}</span> <Plus className="size-5" />
    </Button>
  );
};

export default AddReleaseNote;
